module.exports = __webpack_public_path__ + "media/images/icons/twotone/build-e6c626ea862ec90900b67d3356573bc2.svg";